import { z } from 'zod'; // Add new import

export const TimesheetSingleSchema = z.object({
  id: z.number({
    required_error: 'fieldRequired',
    invalid_type_error: 'fieldRequired',
  }),
  month: z.number({
    required_error: 'fieldRequired',
    invalid_type_error: 'fieldRequired',
  }),
  year: z.number({
    required_error: 'fieldRequired',
    invalid_type_error: 'fieldRequired',
  }),
});
